<template>
  <div>
    <v-dialog scrollable max-width="1200px" v-model="model" persistent>
      <material-card
        :title="$t('components.invoices.new_invoice_dialog.title')"
        :color="$vuetify.theme.themes.light.success"
        icon="add"
        style="overflow-y: auto;"
      >
        <template v-if="invoices === null">
          <v-card-text>
            <v-form v-model="valid">
              <trans-select2
                v-model="selected"
                propertyName="billingPeriod"
                :items="billingPeriods"
                :label="
                  $t('components.invoices.new_invoice_dialog.billing_period')
                "
                :rules="[$rules.required]"
                field="FullName"
                itemValue="Id"
                class="required"
              ></trans-select2>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="$emit('close')" :loading="saving">
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn color="primary" @click="save" :loading="saving">
              {{ $t("components.invoice.new_invoice_dialog.generate") }}
            </v-btn>
          </v-card-actions>
        </template>
        <template v-else>
          <div v-for="(invoice, i) in invoices" :key="i">
            <v-card-text
              v-html="invoice"
            ></v-card-text>
            <iframe
              :name="`print_frame_${i}`"
              width="0"
              height="0"
              frameborder="0"
              src="about:blank"
            ></iframe>
            <v-card-actions>
              <v-btn color="primary" @click="print(invoice, i)">
                {{ $t("globals.print") }}
              </v-btn>
            </v-card-actions>
          </div>
          <v-card-actions>
            <v-btn text @click="$emit('close', invoices)">
              {{ $t("globals.close") }}
            </v-btn>
          </v-card-actions>
        </template>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import ErrorHandler from "@/components/ErrorHandler.vue";
import TransSelect2 from "@/components/TransSelect2.vue";
import { mapActions } from "vuex";
export default {
  props: ["model", "planIdentityId", "billingPeriods"],
  components: {
    ErrorHandler,
    TransSelect2,
  },
  data() {
    return {
      error: null,
      selected: {
        billingPeriod: null,
      },
      saving: false,
      valid: false,
      invoices: null,
    };
  },

  watch: {
    model: {
      handler(v) {
        if (v) {
          this.loadData();
        }
      },
    },
  },
  mounted() {
    console.log("mounted", this.model, this.billingPeriods);
    this.loadData();
  },
  methods: {
    ...mapActions("plansMembers", ["generateInvoice"]),
    loadData() {
      this.selected.billingPeriod = null;
      this.invoices = null;
    },
    async save() {
      //TODO fix payload or id from response
      this.saving = true;
      try {
        this.invoices = (await this.generateInvoice({
          payload: {
            PlanIdentityId: this.planIdentityId,
            BillingPeriodId: this.selected.billingPeriod.Id,
          },
        })).data;
        // this.$emit("saved", ids);
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    print(invoice, i) {
      window.frames[`print_frame_${i}`].document.body.innerHTML = invoice;
      window.frames[`print_frame_${i}`].window.focus();
      window.frames[`print_frame_${i}`].window.print();
    },
  },
};
</script>

<style></style>
